import "./IvStoreConfirmStep.scss";
import {IComponentOptions, IOnDestroy, IOnInit, IScope} from "angular";
import {IvStoreViewStore} from "../../services/IvStoreViewStore";
import {ReplaySubject, Subject} from "rxjs";
import {StripeCardSummaryRecord} from "../../../../stripe/models/StripeBillingRecord";
import {StoreProductStates} from "../../../common/models/StoreProductState";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";
import {Pair} from "../../../../js/util/UtilFunctions";
import {ProductPrices} from "../../models/StoreItemPrices";
import {StoreOrderItemLine} from "../../../common/components/order-items/models/StoreOrderItemLine";
import {IvProductMappings, IvStoreProduct} from "../../models/IvStoreProduct";

export const ConfirmStep = "ivStoreConfirmStep";

export function confirmStep(parentDir: string): IComponentOptions {
    return {
        templateUrl: `${parentDir}/confirm/IvStoreConfirmStep.html`,
        bindings: {
            viewStore: "<"
        },
        controllerAs: "ctrl",
        controller: IvStoreConfirmStepController
    };
}

export class IvStoreConfirmStepController implements IOnInit, IOnDestroy {

    public viewStore: IvStoreViewStore;

    public orderItems: Array<StoreOrderItemLine>;
    public card: StripeCardSummaryRecord | null;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private $scope: IScope) {

    }

    public $onInit(): void {
        this.viewStore
            .productStates
            .takeUntil(this.destroyed$)
            .map((states) => this.buildOrderItems(states))
            .subscribe((items) => {
                this.$scope.$applyAsync(() => this.orderItems = items);
            });
        this.viewStore
            .currentCard
            .takeUntil(this.destroyed$)
            .subscribe((card) => {
                this.$scope.$applyAsync(() => this.card = card);
            });
    }

    private buildOrderItems(states: StoreProductStates<IvStoreProduct>): Array<StoreOrderItemLine> {
        return ObjectUtil.keys(states)
                         .map((k) => Pair(k, states[k]))
                         .filter((p) => p[1].selected)
                         .filter((p) => p[1].locked === false)
                         .filter((p) => p[1].inBundle === false)
                         .map((k) => this.buildLineItem(k[0]));
    }

    private buildLineItem(product: IvStoreProduct): StoreOrderItemLine {
        const mapping = IvProductMappings[product];
        const price = ProductPrices[product];
        const description = mapping.description;
        return {
            description,
            price
        };
    }

    public cardChanged(card: StripeCardSummaryRecord) {
        this.viewStore.updateCard(card);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
